import { Row } from '../grid';
export default Row;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_antd@4.1.3@antd/es/row/index.js
// module id = 32
// module chunks = 0